export class CardContent {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
    static create(document = {}, position = 'left', editable = true, deletable = true, onSave = (document) => ({}), onDeleted = (document) => ({}), onMetadataEdit = (document) => ({}), editing = false) {
        return new CardContent({
            document,
            editable,
            deletable,
            'on-save': onSave,
            'on-deleted': onDeleted,
            'on-metadata-edit': onMetadataEdit,
            position,
            editing,
        });
    }
}
